import { useState } from 'react';

interface Dropped {
  /* The order handed in when the drop was made. */
  over: string;
  ids: string[];
}

/**
 * Holds a list in the order a drop just made until the list handed in changes.
 * A query cache answers a task later, and by then dnd-kit has let go: the rows
 * would slide back to their old places and then forward to the new ones.
 */
export function useDroppedOrder<T extends { id: string }>(
  items: T[],
): [T[], (ids: string[]) => void] {
  const [dropped, setDropped] = useState<Dropped | null>(null);
  const incoming = items.map((item) => item.id).join('\n');

  /* Once the list handed in moves, it is the truth: a refused save included. */
  if (dropped !== null && dropped.over !== incoming) setDropped(null);

  const shown =
    dropped !== null && dropped.over === incoming
      ? dropped.ids
          .map((id) => items.find((item) => item.id === id))
          .filter((item) => item !== undefined)
      : items;

  function hold(ids: string[]) {
    setDropped({ over: incoming, ids });
  }

  return [shown, hold];
}
